  <!-- 浏览所有数据页面 - 查看表格全部记录 -->
<template>
  <div class="browse-data-page">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row class="main-content">
      <el-col :span="4" class="menu-col">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20" class="content-col">
        <!-- 页面标题和操作栏 -->
        <div class="page-header">
          <div class="header-left">
            <h2 class="page-title">
              <i class="el-icon-s-data"></i>
              {{form_name}}
            </h2>
            <p class="page-subtitle">
              共 {{dataList.length}} 条记录，{{headers.length}} 个字段
            </p>
          </div>
          <div class="header-right">
            <!-- <el-button type="primary" class="btn-primary-custom" @click="addRow">
              <i class="el-icon-plus"></i> 添加记录
            </el-button> -->
          </div>
        </div>

        <!-- 数据统计卡片 -->
        <div class="stats-card">
          <div class="stat-item">
            <div class="stat-icon">
              <i class="el-icon-document"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{dataList.length}}</div>
              <div class="stat-label">数据记录</div>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-icon">
              <i class="el-icon-s-grid"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{headers.length}}</div>
              <div class="stat-label">数据字段</div>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-icon">
              <i class="el-icon-time"></i>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{new Date().getFullYear()}}-{{new Date().getMonth()+1}}-{{new Date().getDate()}}</div>
              <div class="stat-label">更新时间</div>
            </div>
          </div>
        </div>

        <!-- 表格内容卡片 -->
        <div class="data-card">
          <div class="card-header">
            <h3 class="card-title">
              <i class="el-icon-tickets"></i>
              数据详情
            </h3>
            <div class="card-actions">
              <el-tooltip content="刷新数据" placement="top">
                <el-button class="btn-refresh" @click="loadData">
                  <i class="el-icon-refresh"></i>
                </el-button>
              </el-tooltip>
            </div>
          </div>

          <div class="table-container">
            <el-table
              :data="dataList"
              stripe
              class="data-table"
              empty-text="暂无数据"
              :header-cell-class-name="'table-header'"
              v-loading="loading">

              <el-table-column
                header-align="center"
                resizable
                align="center"
                :key="header"
                :label="header.label"
                :prop="header.prop"
                v-for="(header, index) in headers"
                :min-width="header.type === '文本' ? '180' : '120'">

                <template slot="header" slot-scope="scope">
                  <div class="column-header">
                    <div class="column-name" :class="header.optional === '1' ? 'optional' : 'required'">
                      {{header.label}}
                    </div>
                    <div class="column-meta">
                      <span class="type-badge">{{header.type}}</span>
                      <span class="optional-badge" :class="header.optional === '1' ? 'optional' : 'required'">
                        {{getOptionlabel(header)}}
                      </span>
                    </div>
                  </div>
                </template>

                <template slot-scope="scope">
                  <!-- 图片类型 -->
                  <div v-if="header.type === '图片'" class="media-cell">
                    <span v-if="scope.row[header.prop]">
                      <el-button
                        type="text"
                        class="media-link"
                        @click="openUrl(scope.row[header.prop])">
                        <i class="el-icon-picture"></i> 查看图片
                      </el-button>
                    </span>
                    <span v-else class="empty-media">-</span>
                  </div>

                  <!-- 签名类型 -->
                  <div v-else-if="header.type === '签名'" class="media-cell">
                    <span v-if="scope.row[header.prop]">
                      <el-button
                        type="text"
                        class="media-link"
                        @click="openUrl(scope.row[header.prop])">
                        <i class="el-icon-edit"></i> 查看签名
                      </el-button>
                    </span>
                    <span v-else class="empty-media">-</span>
                  </div>

                  <!-- 视频类型 -->
                  <div v-else-if="header.type === '视频'" class="media-cell">
                    <span v-if="scope.row[header.prop]">
                      <el-button
                        type="text"
                        class="media-link"
                        @click="openUrl(scope.row[header.prop])">
                        <i class="el-icon-video-play"></i> 观看视频
                      </el-button>
                    </span>
                    <span v-else class="empty-media">-</span>
                  </div>

                  <!-- 文件类型 -->
                  <div v-else-if="header.type === '文件'" class="media-cell">
                    <span v-if="scope.row[header.prop]">
                      <el-button
                        type="text"
                        class="media-link"
                        @click="openUrl(scope.row[header.prop])">
                        <i class="el-icon-document"></i> 下载文件
                      </el-button>
                    </span>
                    <span v-else class="empty-media">-</span>
                  </div>

                  <!-- 其他类型 -->
                  <div v-else class="text-cell">
                    <div class="cell-content" :title="scope.row[header.prop]">
                      {{scope.row[header.prop] || '-'}}
                    </div>
                  </div>
                </template>
              </el-table-column>

              <!-- 操作列 -->
              <el-table-column fixed="right" label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <div class="action-buttons">
                    <el-tooltip content="删除此记录" placement="top">
                      <el-button
                        @click="deleteRecord(scope.row)"
                        type="text"
                        size="small"
                        class="btn-delete">
                        <i class="el-icon-delete"></i>
                      </el-button>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 空状态提示 -->
          <div v-if="dataList.length === 0 && !loading" class="empty-state">
            <i class="el-icon-s-data"></i>
            <p>暂无数据记录</p>
            <el-button type="primary" size="small" @click="addRow">添加第一条记录</el-button>
          </div>

          <!-- 表格底部 -->
          <div class="table-footer" v-if="dataList.length > 0">
            <div class="footer-left">
              显示 <strong>{{dataList.length}}</strong> 条记录
            </div>
            <div class="footer-right">
              <span class="record-tip">
                <i class="el-icon-info"></i>
                单击媒体链接可查看详情
              </span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        form_id: '',
        form_name: '',
        dataList: [],
        headers: [],
        loading: false,
        username: ''
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name
      // this.loadCourses()
      this.loadData()
    },
    methods: {
      loadData() {
        let that = this
        this.loading = true

        var requestUrl = '/form/web/_load_form_all_data.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id
            }
          }).then(function(response) {
            that.dataList = response.data.dataList
            that.headers = response.data.headers
            that.loading = false
          })
          .catch(function(error) {
            console.log(error)
            that.loading = false
          })
      },
      deleteRecord(row) {
        let that = this

        var data_row_id = row.data_row_id

        this.$confirm('此操作将永久删除该行, 要删除吗?', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.deleteRow(data_row_id)
        }).catch(() => {
          // that.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })

        console.log(data_row_id)
      },
      deleteRow(data_row_id) {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_delete_row_by_data_row_id.jsp'
        this.axios.get(requestUrl, {
            params: {
              data_row_id: data_row_id
            }
          }).then(function(response) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })

            load.close()

            that.loadData()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      addRow() {
        let that = this
        this.$router.push({
          name: 'add_record',
          params: {
            form_id: that.form_id,
            form_name: that.form_name
          }
        })
      },
      getOptionlabel(header) {
        if (header.optional == '1') {
          return '选填'
        } else {
          return '必填'
        }
      },
      openUrl(url) {
        window.open(url)
      },
      getImageFileUrl(field_value) {
        console.log("数据值：",field_value)
        var url = ''
        if (field_value.indexOf('"]') > 0) {
          url = field_value.replace('["', '')
          url = url.replace('"]', '')
          console.log(url)
        }

        return url
      },
      isValidURL(str) {
        if (str) {
          if (str.indexOf('http://') >= 0 || str.indexOf('https://') >= 0) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    }
  }
</script>

<style scoped>
  /* 页面整体 */
  .browse-data-page {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content {
    padding: 20px;
  }

  .menu-col {
    padding-right: 20px;
  }

  .content-col {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
    padding: 30px;
    min-height: calc(100vh - 140px);
  }

  /* 页面标题 */
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }

  .header-left {
    flex: 1;
  }

  .page-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0 0 8px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .page-title i {
    color: #1485FB;
    font-size: 28px;
  }

  .page-subtitle {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  /* 主按钮样式 */
  .btn-primary-custom {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    border-radius: 8px;
    padding: 10px 24px;
    font-size: 14px;
    color: #fff;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(20, 133, 251, 0.3);
  }

  .btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(20, 133, 251, 0.4);
  }

  /* 统计卡片 */
  .stats-card {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
  }

  .stat-item {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;
  }

  .stat-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
  }

  .stat-content {
    flex: 1;
  }

  .stat-value {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    line-height: 1;
    margin-bottom: 4px;
  }

  .stat-label {
    font-size: 13px;
    color: #666;
  }

  /* 数据卡片 */
  .data-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0f0f0;
    overflow: hidden;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-bottom: 1px solid #e8e8e8;
  }

  .card-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .card-title i {
    color: #1485FB;
  }

  .btn-refresh {
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    padding: 8px;
    color: #555;
    transition: all 0.3s ease;
  }

  .btn-refresh:hover {
    border-color: #1485FB;
    color: #1485FB;
    background: #f0f7ff;
  }

  /* 表格容器 */
  .table-container {
    overflow-x: auto;
    padding: 0;
  }

  .data-table {
    width: 100%;
    border: none;
  }

  ::v-deep .data-table .table-header th {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
    color: #495057;
    font-weight: 600;
    font-size: 13px;
    padding: 16px 12px;
    border-bottom: 2px solid #e8e8e8;
  }

  ::v-deep .data-table .el-table__row {
    transition: background-color 0.3s ease;
  }

  ::v-deep .data-table .el-table__row:hover {
    background-color: #f8f9fa !important;
  }

  ::v-deep .data-table .el-table__cell {
    padding: 12px;
    border-bottom: 1px solid #f0f0f0;
  }

  /* 列头样式 */
  .column-header {
    text-align: center;
    padding: 4px 0;
  }

  .column-name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 6px;
    line-height: 1.2;
  }

  .column-name.required {
    color: #cf1322;
  }

  .column-name.optional {
    color: #555;
  }

  .column-meta {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
  }

  .type-badge {
    background: #e6f7ff;
    color: #1485FB;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 500;
  }

  .optional-badge {
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 500;
  }

  .optional-badge.required {
    background: #fff2f0;
    color: #cf1322;
  }

  .optional-badge.optional {
    background: #f6ffed;
    color: #389e0d;
  }

  /* 单元格样式 */
  .media-cell {
    text-align: center;
    padding: 8px 0;
  }

  .media-link {
    color: #1485FB !important;
    font-size: 13px;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.3s ease;
  }

  .media-link:hover {
    background: #f0f7ff;
    color: #0d6efd !important;
  }

  .media-link i {
    margin-right: 4px;
  }

  .empty-media {
    color: #999;
    font-size: 13px;
  }

  .text-cell {
    padding: 8px 0;
  }

  .cell-content {
    font-size: 13px;
    color: #555;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  /* 操作按钮 */
  .action-buttons {
    display: flex;
    justify-content: center;
    gap: 8px;
  }

  .btn-delete {
    color: #f56c6c !important;
    padding: 6px;
    border-radius: 4px;
    transition: all 0.3s ease;
  }

  .btn-delete:hover {
    background: #fff2f0;
  }

  /* 空状态 */
  .empty-state {
    text-align: center;
    padding: 60px 20px;
  }

  .empty-state i {
    font-size: 48px;
    color: #d9d9d9;
    margin-bottom: 15px;
  }

  .empty-state p {
    color: #999;
    margin-bottom: 20px;
  }

  /* 表格底部 */
  .table-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #f8f9fa;
    border-top: 1px solid #e8e8e8;
    font-size: 13px;
    color: #666;
  }

  .footer-left strong {
    color: #333;
  }

  .record-tip {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #888;
  }

  .record-tip i {
    color: #1485FB;
  }

  /* 响应式设计 */
  @media (max-width: 992px) {
    .main-content {
      padding: 15px;
    }

    .content-col {
      padding: 20px;
    }

    .page-header {
      flex-direction: column;
      gap: 15px;
    }

    .stats-card {
      grid-template-columns: 1fr;
    }

    .card-header {
      flex-direction: column;
      gap: 15px;
      align-items: flex-start;
    }

    .table-footer {
      flex-direction: column;
      gap: 10px;
      text-align: center;
    }
  }

  @media (max-width: 768px) {
    .menu-col {
      padding-right: 0;
      margin-bottom: 15px;
    }

    .content-col {
      min-height: auto;
    }

    .page-title {
      font-size: 20px;
    }

    .card-title {
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/browse_all_data.vue